<template>
  <div class="success-metrics__group">
    <div class="success-metrics__group-radio" v-ripple="{ class: 'info--text text--lighten-2' }" @click="setObjective">
      <v-icon v-if="selected" color="primary">radio_button_checked</v-icon>
      <v-icon v-else color="primary">radio_button_unchecked</v-icon>
    </div>
    <div class="success-metrics__group-label">
      <h2 class="success-metrics__group-label-title"> {{ objective.title }}
        <span v-if="objective.label" class="success-metrics__group-label-chip">Most recommended</span>
      </h2>
      <p class="success-metrics__group-label-subtitle"> {{ objective.description }} </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessMetric',
  props: {
    objective: {
      type: Object,
      default: () => {}
    },
    selectedObjective: {
      type: String,
      default: ''
    }
  },
  computed: {
    selected () {
      return this.objective.value === this.selectedObjective
    }
  },
  methods: {
    setObjective () {
      this.$emit('setObjective', this.objective.value)
    }
  }
}
</script>
<style lang="scss">
  $chip-color: rgb(61, 61, 61);
  $chip-background: rgb(134, 188, 188);

  .success-metrics {
    &__group {
      display: flex;
      align-items: flex-start;
      &-radio {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
        height: 40px;
        width: 40px;
      }
      &-label {
        padding-top: .25rem;
        margin-left: .5rem;
        &-title {
          font-size: 1.3rem;
          font-weight: 600;
        }
        &-chip {
          margin-left: 2rem;
          display: inline-block;
          padding: .05rem .75rem;
          color: $chip-color;
          font-weight: 600;
          font-size: .7em;
          background: $chip-background;
        }
      }
    }
  }
</style>
